(function () {
    let slotLicense = {
        $wrapper: null,
        re: null,
        currentUrl: window.location.href,

        init: function () {
            slotLicense.$wrapper = $('.slot-license-usage');
            slotLicense.control();
        },
        control: function () {
            slotLicense.$wrapper.on('click', 'tbody tr', function (e) {
                if (!slotLicense.currentUrl.includes('contentId')) {
                    window.location.href = $(this).data('href');
                } else {
                    let currentURL = new URL(slotLicense.currentUrl);
                    const params = new URLSearchParams(currentURL.search);

                    const trElement = e.target.closest('tr');
                    const newContentId = trElement?.getAttribute('data-contentId');
                    const newSelectedId = trElement?.getAttribute('data-selectedId');

                    params.set('contentId', newContentId);
                    params.set('selectedId', newSelectedId);
                    currentURL.search = params.toString(); // Update the search property of the URL object with the updated parameters

                    window.location.href = currentURL.href;
                }
            });

            slotLicense.$wrapper.on('click', '.licenseReportForm', function (e) {
                e.stopPropagation();
            });

            slotLicense.$wrapper.on('click', '.licenseReportBtn', function (e) {
                e.stopPropagation();
                UX.dropBlock.on.hide();
                UX.dropBlock.$controller = $(this);
                UX.dropBlock.find.target();
                UX.dropBlock.on.show(e);
            });

            slotLicense.$wrapper.on('click', '.licenseReportForm [type="cancel"]', function (e) {
                e.preventDefault();
                UX.dropBlock.on.hide();
            });

            slotLicense.$wrapper.on('click', '.licenseReportForm [type="submit"]', function (e) {
                e.preventDefault();
                slotLicense.sendReport(e, $(this));
            });
        },

        sendReport: function (e, $el) {
            let $form = $el.closest('form');
            let ajaxUrl = $form.attr('action');
            let ajaxData = $form.serialize();
            let inputVal = $form.find('[name="emailAddress"]').val();
            let re = '';

            let successMsg =
                '<span class="success"><i class="icon-checkmark" aria-hidden="true"></i>The report has been sent successfully</span>';
            let errorEmptyMsg =
                '<span class="error"><i class="icon-tools_close" aria-hidden="true"></i>Please enter a valid Email</span>';
            let errorMsg =
                '<span class="error"><i class="icon-tools_close" aria-hidden="true"></i>The report has not been sent, please try again</span>';

            if (inputVal === '') {
                slotLicense.hideForm(e, $el, errorEmptyMsg);
                return;
            } else {
                re =
                    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (!re.test(inputVal)) {
                    slotLicense.hideForm(e, $el, errorEmptyMsg);
                    return;
                }
            }

            $.ajax({
                url: ajaxUrl + '&' + ajaxData,
                type: 'POST',

                success: function () {
                    slotLicense.hideForm(e, $el, successMsg);
                },

                error: function () {
                    slotLicense.hideForm(e, $el, errorMsg);
                },
            });
        },
        hideForm: function (e, $el, msg) {
            UX.dropBlock.on.show(e);
            UX.dropBlock.on.hide();
            UX.dropBlock.$controller = $el;
            UX.dropBlock.find.target();
            UX.dropBlock.on.show(e);
            UX.dropBlock.$target.find('.infoBox').html(msg);
        },
    };
    UX.slotLicense = slotLicense;
})();
